<div id="{{ id }}" class="bespoke-slide {{ classes }}">
    <div class="scroll">
        <div class="scroll__text">Scroll or use your keyboard to continue</div>
    </div>
    <slot>
        {{#if slide.title}}
            <h2>{{ slide.title }}</h2>
        {{/if}}

        {{#if slide.bg_img}}
            <div class="media-outer">
                <img src="{{slide.bg_img}}" alt="" />
            </div>
        {{/if}}

        {{#if slide.text}}
            <div>{{ slide.text }}</div>
        {{/if}}
    </slot>
    {{#if slide.modal }}
        {{#each slide.modal as modal, n}}
        <Modal slideIndex={{i}} modalIndex={{n}} :modal />
        {{/each}}
    {{/if}}
</div>

<script>
import Modal from './Modal.html'
export default {

    components: {
        Modal,
    },

    data() {
        return {
            slide: {},
            i: 0,
        }
    },

    computed: {
        id: slide => slide.slug ? slide.slug : slide._id,
        classes: ($current_slide, i) => {
            let classes = i == $current_slide ? 'bespoke-active' : 'bespoke-inactive';
            if (i < $current_slide) classes += ' bespoke-before'; 
            if (i > $current_slide) classes += ' bespoke-after';
            return classes;
        }
    },
}
</script>